import { __ } from "src/libs/utilities"
import ListResults from "./results/ListResults"
import { ITestProps } from "./SingleTest"
import ExternalFinish from "./ExternalFinish"
import { ITestsStore, useTestsStore } from "../../data/store"

const Results = ({ item, ...props }: ITestProps) : JSX.Element => { 
  const results: any[]        = useTestsStore((state: ITestsStore) => state.results )  
  return <>
    <div 
        dangerouslySetInnerHTML={{ __html: __("Results") }} 
        className={"pe-matchings-finish-label " } 
    />
    <ListResults item={item} />
  </>
  
} 

export default Results